import classNames from 'classnames';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import logo from 'assets/img/logo-white-full.png';

function InfoItem( {
  title, subtitle, icon, className, link,
}: {
  title: string, subtitle: string, icon: string, className?: string, link?: string } ) {
  return (
    <Row className={classNames( 'align-items-center', className, {
      'gx-2': !className,
    } )}
    >
      <Col xs="auto">
        <i className={classNames( 'icon', icon )} />
      </Col>
      <Col>
        <p className="mb-1 title">{title}</p>
        <a className="subtitle m-0" href={link} target="_blank" rel="noreferrer">{subtitle}</a>
      </Col>
    </Row>
  );
}

function Footer() {
  return (
    <div className="app-footer">
      <div className="app-footer-info">
        <Row className="m-0">
          <Col xs={8} md={9} lg={7} className="m-auto">
            <Row className="d-md-none">
              <Col className="text-center">
                <img src={logo} alt="Grupo Impar" height={36} />
              </Col>
            </Row>

            <Row>
              <Col md className="info-item">
                <InfoItem
                  title="DIRECCIÓN"
                  subtitle="C/ Serrano 45, 2. Madrid"
                  link="https://www.google.com/maps?q=Calle+Serrano+45,+Madrid"
                  icon="icon-map-pin"
                />
              </Col>

              <Col md className="d-flex justify-content-start justify-content-md-center info-item">
                <InfoItem
                  title="EMAIL"
                  subtitle="info@imparcapital.com"
                  link="mailto:info@imparcapital.com"
                  icon="icon-mail"
                  className="gx-3"
                />
              </Col>

              <Col md className="d-flex justify-content-start justify-content-md-end info-item">
                <InfoItem
                  title="TELÉFONO"
                  subtitle="+34 912900302"
                  link="tel:+34912900302"
                  icon="icon-phone"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <Row className="logo d-none d-md-block m-0">
        <Col md={8} lg={7} className="m-auto">
          <Row>
            <Col className="text-center">
              <img src={logo} alt="Grupo Impar" height={46} />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="m-0">
        <Col md={8} lg={7} className="m-auto legal-info">
          <Row className="m-0">
            <Col md={7} className="order-2 order-md-1 text-center text-md-start">
              <p className="title m-0">
                <span className="d-block d-md-inline">
                  <i className="icon-copyright" />
                  {new Date().getFullYear()}
                  {' '}
                  Impar Capital.
                  {' '}
                </span>
                <span className="d-block d-md-inline">Todos los derechos reservados.</span>
              </p>
            </Col>
            <Col className="d-flex justify-content-end order-1 order-md-2 flex-column flex-md-row text-center text-md-start">
              <a className="title mb-3 mb-md-0" href="/">
                Aviso Legal
              </a>
              <a className="title mx-md-4 mb-3 mb-md-0" href="/">
                Política de cookies
              </a>
              <a className="title mb-3 mb-md-0" href="/">
                Sistema Interno de Información
              </a>

            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default Footer;
